enum CycleSettings {
  PostWeld = 'post-weld',
  PreHeat = 'pre-heat',
  PercentageTimer = 'percentage-timer',
  Recorder = 'recorder',
}

export default CycleSettings;
